module.exports = __webpack_public_path__ + "img/mobile-btn-android.05e6f041.webp";